export const SPECIAL_TAGS = {
  MAMMOGRAPHY: 'mammography',
  BREAST_MRI: 'breast_mri',
};
